import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import styles from "../../css/lineTime.module.css";
import icons from "../../css/icons.module.css";
import ParticlesComponent from "../../components/particles/particles";

export default function App() {


  useEffect(() => {
    AOS.init({
      offset: 80,
      duration: 800,
      easing: "ease-in-out",
      once: true,
      once: false

    });
  }, []);

  return (
    <div className={styles.containerMain} >
   

      <div data-aos="fade-down" className={styles.sectionProject}>
        <p className={styles.titlePage}   >Mi recorrido</p>

        <div className={styles.containerFlex}>
          <div>
            {/* Línea y tarjeta 2018 */}
            <div data-aos="fade-down" className={styles.lineTime}></div>



            <div data-aos="zoom-in-down" className={styles.marker}>
              <div className={styles.cardLeft}>
                <div className={styles.containerDescription}>
                  <p className={styles.titleTimeCard}>2018</p>
                  <p className={styles.titleTimeCard}>Participación en la expo ingeniería 2018</p>
                  <p className={styles.descTimeCard}>
                    Finalista a nivel nacional con una solución innovadora para reducir filas y optimizar el uso de recursos en colegios.
                  </p>
                </div>
              </div>
            </div>

            {/* Línea y tarjeta 2020 */}
            <div data-aos="fade-down" className={styles.lineTime}></div>
            <div data-aos="zoom-in-down" className={styles.marker}>
              <div className={styles.cardRight}>
                <div className={styles.containerDescription}>
                  <p className={styles.titleTimeCard}>2020</p>
                  <p className={styles.titleTimeCard}>Pasantía laboral</p>
                  <p className={styles.descTimeCard}>
                    Trabajo en el Departamento de TI del Hotel Arenas del Mar, brindando soporte técnico y mejorando procesos internos.
                  </p>
                </div>
              </div>
            </div>

            {/* Línea y tarjeta 2023 */}
            <div data-aos="fade-down" className={styles.lineTime}></div>
            <div data-aos="zoom-in-down" className={styles.marker}>
              <div className={styles.cardLeft}>
                <div className={styles.containerDescription}>
                  <p className={styles.titleTimeCard}>2023</p>
                  <p className={styles.titleTimeCard}>Proyecto Freelance</p>
                  <p className={styles.descTimeCard}>
                    Lanzamiento de mi primer proyecto independiente bajo la marca Alight, desarrollando una página web para reservación de tours.
                  </p>
                </div>
              </div>
            </div>

            {/* Línea y tarjeta actual */}
            <div data-aos="fade-down" className={styles.lineTime}></div>
            <div data-aos="zoom-in-down" className={styles.marker}>
              <div  className={styles.cardRight}>
                <div className={styles.containerDescription}>
                  <p className={styles.titleTimeCard}>Hoy</p>
                  <p className={styles.titleTimeCard}>Desarrollando mi mejor persona</p>
                  <p className={styles.descTimeCard}>
                    Comprometido con el aprendizaje y el perfeccionamiento constante de mis habilidades sin rendirme.
                  </p>
                </div>
              </div>
            </div>

            <div data-aos="fade-down" className={styles.lineTime}></div>
          </div>
        </div>
      </div>
    </div>
  );
}
